import React from 'react'

// hooks
import { useOktaAuth } from '@okta/okta-react'

// components
import Login from './components/login'
import Dashboard from './components/dashboard'

function Home() {
    const { authState } = useOktaAuth()
    if (!authState?.isAuthenticated) {
        return <Login />
    }
    return <Dashboard />
}

export default Home
